<template>
  <div class="my-wrap finance-wrap">
    <div class="withdraw-frame withdraw-m-frame">
      <div class="my-withdraw-mobile-package withdraw-mobile">
        <div class="mobile-frame">
          <WithdrawTabNav
            :is-crypto-exchange="false"
            @toggle-mode="$emit('toggle-mode')"
          />

          <div class="slider-form withdraw-slider-form">
            <div class="slider">
              <form class="row-frame dep-form-frame gx-3 form-row-gap">
                <CoinSelector
                  :is-crypto="withdrawType === 3"
                  :is-crypto-exchange="false"
                  :selected-coin="selectedCoin"
                  :selected-wallet="selectedWallet"
                  :coin-list="coinList"
                  :main-wallet="mainWallet"
                  @select-crypto="onSelectCrypto"
                  @select-non-crypto="selectNonCryptoWallet"
                />
                <WalletSelector
                  :is-crypto="withdrawType === 3"
                  :selected-wallet="selectedWallet"
                  :selected-wallet-key="selectedWalletKey"
                  :selected-chain="selectedChain"
                  :non-crypto-wallets="nonCryptoWallets"
                  :chain-list="chainList"
                  @select-non-crypto="selectNonCryptoWallet"
                  @select-chain="onSelectChain"
                />

                <AmountInput
                  :amount.sync="postForm.amount"
                  :withdrawal-limit="withdrawalLimit"
                  :amount-limit="amount_limit"
                  :is-crypto-exchange="false"
                  :currency="brand.currency"
                  :is-integer-wallet="isIntegerWallet"
                  input-id="withdraw-amount-mb"
                  @set-all="setAllAmount"
                />
                <WithdrawLimitInfo
                  :withdrawal-limit="withdrawalLimit"
                  :amount-limit="amount_limit"
                  :is-crypto-exchange="false"
                  :currency="brand.currency"
                  input-id="withdraw-amount-mb"
                />

                <hr class="withdraw-pw-divider">

                <div v-if="withdrawType === 3 && isCryptoSelect" class="colu-12">
                  <label class="colu-12 for-label" for="crypto-address-mb">
                    {{ $t('Bao.withdrawal_address') }}
                  </label>
                  <input
                    id="crypto-address-mb"
                    v-model="postForm.address"
                    v-validate="'required'"
                    class="for-input inpType"
                    :class="{ 'isInvalid': errors.has('address-mb') }"
                    type="text"
                    :placeholder="$t('Bao.withdrawal_address')"
                    autocomplete="off"
                    name="address-mb"
                  >
                  <div v-if="errors.has('address-mb')" class="input-feedback text-align-R">
                    {{ $t('Bao.wallet_address_error') }}
                  </div>
                </div>

                <DestinationTagInput
                  v-if="selectedChain && selectedChain.supportMemo"
                  :selected-chain="selectedChain"
                  :memo.sync="memo"
                  @copy="copyTextHelper"
                />

                <PaymentUseBank
                  v-if="withdrawType !== 3"
                  :show-bank-select="withdrawType !== 3"
                  :member-bank-id="postForm.member_bank_id"
                  :selected-bank-name="selectedBankName"
                  :my-banks="myBanks"
                  @select-bank="onSelectBank"
                />
                <PaymentUseJeton
                  v-if="withdrawType !== 3 && selectedBankTypeCode === 'JetonPay'"
                  :withdrawal-info="withdrawal_info"
                  :jeton-errors="jetonErrors"
                  @update:withdrawal-info="withdrawal_info = $event"
                  @check-jeton-errors="checkJetonErrors"
                />
                <PaymentUseVega
                  v-if="withdrawType !== 3 && selectedBankTypeCode === 'VegaWallet'"
                  :withdrawal-info="withdrawal_info"
                  :account-errors="accountErrors"
                  @update:withdrawal-info="withdrawal_info = $event"
                  @check-account-errors="checkAccountErrors"
                />

                <AuthInput
                  :google-auth-enabled="google_auth_totp_status"
                  :withdrawal-pass.sync="postForm.withdrawal_pass"
                  :otp-code.sync="postForm.opt_code"
                  input-id="auth-input-mb"
                />

                <WithdrawSummary
                  :is-crypto="withdrawType === 3"
                  :display-amount="postForm.amount > 0 ? postForm.amount : 0"
                  :bonus-gold="bonusGold"
                  :currency="brand.currency"
                />

                <AgreeCheckbox
                  :agree.sync="agree"
                  :agree-tip="agreeTip"
                  checkbox-id="agree-mb"
                />
              </form>
            </div>
          </div>

          <div
            class="button-style-w100 btn-primary"
            :class="{ disabled: !checkInput() }"
            @click="checkIsWithdraw"
          >
            {{ $t('Bao.send') }}
          </div>

          <div v-if="themeConfig.showWithdrawalDesc" @click="$router.push('/page/support')">
            <a class="help-deposit-n">
              <span class="icon-help">?</span>
              <span class="help-text">{{ $t('Bao.withdrawal_description') }}</span>
            </a>
          </div>
        </div>
      </div>

      <div class="pc-withdraw-layout">
        <WithdrawSidebar
          :is-crypto-exchange="false"
          @toggle-mode="$emit('toggle-mode')"
        />

        <div class="my-withdraw-frame">
          <div class="my-deposit my-d-box">
            <div class="slider-form withdraw-container">
              <div class="slider">
                <form class="row-frame dep-form-frame gx-3 form-row-gap">
                  <CoinSelector
                    :is-crypto="withdrawType === 3"
                    :is-crypto-exchange="false"
                    :selected-coin="selectedCoin"
                    :selected-wallet="selectedWallet"
                    :coin-list="coinList"
                    :main-wallet="mainWallet"
                    @select-crypto="onSelectCrypto"
                    @select-non-crypto="selectNonCryptoWallet"
                  />
                  <WalletSelector
                    :is-crypto="withdrawType === 3"
                    :selected-wallet="selectedWallet"
                    :selected-wallet-key="selectedWalletKey"
                    :selected-chain="selectedChain"
                    :non-crypto-wallets="nonCryptoWallets"
                    :chain-list="chainList"
                    @select-non-crypto="selectNonCryptoWallet"
                    @select-chain="onSelectChain"
                  />

                  <AmountInput
                    :amount.sync="postForm.amount"
                    :is-crypto-exchange="false"
                    :is-integer-wallet="isIntegerWallet"
                    input-id="withdraw-amount-pc"
                    @set-all="setAllAmount"
                  />
                  <WithdrawLimitInfo
                    :withdrawal-limit="withdrawalLimit"
                    :amount-limit="amount_limit"
                    :is-crypto-exchange="false"
                    :currency="brand.currency"
                    input-id="withdraw-amount-pc"
                  />

                  <hr class="withdraw-pw-divider">

                  <PaymentUseBank
                    v-if="withdrawType !== 3"
                    :show-bank-select="withdrawType !== 3"
                    :member-bank-id="postForm.member_bank_id"
                    :selected-bank-name="selectedBankName"
                    :my-banks="myBanks"
                    @select-bank="onSelectBank"
                  />
                  <PaymentUseJeton
                    v-if="withdrawType !== 3 && selectedBankTypeCode === 'JetonPay'"
                    :withdrawal-info="withdrawal_info"
                    :jeton-errors="jetonErrors"
                    @update:withdrawal-info="withdrawal_info = $event"
                    @check-jeton-errors="checkJetonErrors"
                  />
                  <PaymentUseVega
                    v-if="withdrawType !== 3 && selectedBankTypeCode === 'VegaWallet'"
                    :withdrawal-info="withdrawal_info"
                    :account-errors="accountErrors"
                    @update:withdrawal-info="withdrawal_info = $event"
                    @check-account-errors="checkAccountErrors"
                  />

                  <div v-if="withdrawType === 3 && isCryptoSelect" class="colu colu-12">
                    <label class="colu-12 for-label">
                      {{ $t('Bao.withdrawal_address') }}
                    </label>
                    <input
                      v-model="postForm.address"
                      v-validate="'required'"
                      class="for-input inpType"
                      :class="{ 'isInvalid': errors.has('address-pc') }"
                      type="text"
                      :placeholder="$t('Bao.withdrawal_address')"
                      autocomplete="off"
                      name="address-pc"
                    >
                    <div v-if="errors.has('address-pc')" class="input-feedback text-align-R">
                      {{ $t('Bao.wallet_address_error') }}
                    </div>
                  </div>

                  <DestinationTagInput
                    v-if="selectedChain && selectedChain.supportMemo"
                    :selected-chain="selectedChain"
                    :memo.sync="memo"
                    @copy="copyTextHelper"
                  />

                  <AuthInput
                    :google-auth-enabled="google_auth_totp_status"
                    :withdrawal-pass.sync="postForm.withdrawal_pass"
                    :otp-code.sync="postForm.opt_code"
                    input-id="auth-input-pc"
                  />

                  <WithdrawSummary
                    :is-crypto="withdrawType === 3"
                    :display-amount="postForm.amount > 0 ? postForm.amount : 0"
                    :bonus-gold="bonusGold"
                    :currency="brand.currency"
                  />

                  <AgreeCheckbox
                    :agree.sync="agree"
                    :agree-tip="agreeTip"
                    checkbox-id="agree-pc"
                  />

                  <div
                    class="button-style-w100 btn-primary"
                    :class="{ disabled: !checkInput() }"
                    @click="checkIsWithdraw"
                  >
                    {{ $t('Bao.send') }}
                  </div>

                  <div v-if="themeConfig.showWithdrawalDesc" @click="$router.push('/page/support')">
                    <a class="help-deposit-n">
                      <span class="icon-help">?</span>
                      <span class="help-text">{{ $t('Bao.withdrawal_description') }}</span>
                    </a>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div v-if="showModel" class="popup-wrap text-center" :class="{ active: showModel }">
      <div class="popup-box">
        <div class="popup-success">
          <h5>{{ handleWithdrawText }}</h5>
          <button class="button-style-5" @click="doWithdrawal">
            <span>{{ $t('Bao.submit') }}</span>
          </button>
          <button class="button-style-5" @click="showModel = false">
            <span>{{ $t('Bao.cancel') }}</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { withdrawalCheck, withdrawalPayment } from '@/api/payment'
import { getMyBanks } from '@/api/bank'
import { showNotice, setErrorMessage, copyText, detectMob } from '@/utils/tool'
import crypto from 'crypto-js'
import { mapGetters } from 'vuex'
import themeMixin from '@/mixins/themeMixin'
import paymentMixin from '@/mixins/paymentMixin'

import WithdrawTabNav from '@/views/withdraw/WithdrawTabNav'
import WithdrawSidebar from '@/views/withdraw/WithdrawSidebar'
import CoinSelector from '@/views/withdraw/CoinSelector'
import WalletSelector from '@/views/withdraw/WalletSelector'
import AmountInput from '@/views/withdraw/AmountInput'
import WithdrawLimitInfo from '@/views/withdraw/WithdrawLimitInfo'
import DestinationTagInput from '@/views/withdraw/DestinationTagInput'
import AuthInput from '@/views/withdraw/AuthInput'
import WithdrawSummary from '@/views/withdraw/WithdrawSummary'
import AgreeCheckbox from '@/views/withdraw/AgreeCheckBox'
import PaymentUseBank from '@/views/withdraw/PaymentUseBank.vue'
import PaymentUseJeton from '@/views/withdraw/PaymentUseJeton.vue'
import PaymentUseVega from '@/views/withdraw/PaymentUseVega.vue'

export default {
  name: 'WithdrawDefaultForm',
  inject: ['$validator'],
  components: {
    WithdrawTabNav,
    WithdrawSidebar,
    CoinSelector,
    WalletSelector,
    AmountInput,
    WithdrawLimitInfo,
    DestinationTagInput,
    AuthInput,
    WithdrawSummary,
    AgreeCheckbox,
    PaymentUseBank,
    PaymentUseJeton,
    PaymentUseVega
  },
  mixins: [themeMixin, paymentMixin],
  props: {
    shared: {
      type: Object,
      required: true
    },
    common: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      withdrawType: '',
      myBanks: [],
      selectedBankName: this.$t('Bao.select_bankcard'),
      selectedBankTypeCode: '',
      withdrawalCheckData: {
        amount: null,
        withdrawal_fee: null,
        actual_amount: null,
        status: null,
        require_performance: null,
        performance_need: null,
        current_performance: null
      },
      withdrawal_info: {},
      accountErrors: [' '],
      jetonErrors: [' '],
      showModel: false,
      availableWithdrawalTypes: { 1: false, 2: false, 3: true },
      isMainWallet: true,
      memo: '',
      defaultInitialized: false,
      isWithdraw: true,
      isWithdrawalFull: false,
      fullAmount: 0,
      typeDescriptions: {}
    }
  },
  computed: {
    ...mapGetters(['memberInfo', 'brand', 'brandInfo', 'bonusGold', 'user', 'permissionInfo', 'app']),
    before_withdrawal_module_setting() {
      return this.brandInfo.before_withdrawal_module_setting
    },
    max_withdrawal_amount() {
      return this.before_withdrawal_module_setting
        ? this.before_withdrawal_module_setting.max_withdrawal_amount
        : 0
    },
    handleWithdrawText() {
      return this.$t('Bao.is_handle_withdraw', { limit: this.max_withdrawal_amount })
    },
    first_deposit_at() {
      return this.memberInfo.first_deposit_at
    },
    google_auth_totp_status() {
      return this.common.google_auth_totp_status
    },
    agree: {
      get() { return this.shared.agree },
      set(value) { this.shared.agree = value }
    },
    agreeTip() {
      return this.shared.agreeTip
    },
    postForm() {
      return this.shared.postForm
    },
    wallets() {
      return this.shared.wallets
    },
    mainWallet: {
      get() { return this.shared.mainWallet },
      set(value) { this.shared.mainWallet = value }
    },
    coinList() {
      return this.shared.coinList
    },
    paymentFeeData() {
      return this.shared.paymentFeeData
    },
    selectedWallet: {
      get() { return this.shared.selectedWallet },
      set(value) { this.shared.selectedWallet = value }
    },
    selectedWalletKey: {
      get() { return this.shared.selectedWalletKey },
      set(value) { this.shared.selectedWalletKey = value }
    },
    selectedCoin: {
      get() { return this.shared.selectedCoin },
      set(value) { this.shared.selectedCoin = value }
    },
    selectedChain: {
      get() { return this.shared.selectedChain },
      set(value) { this.shared.selectedChain = value }
    },
    chainList: {
      get() { return this.shared.chainList },
      set(value) { this.shared.chainList = value }
    },
    isCryptoSelect: {
      get() { return this.shared.isCryptoSelect },
      set(value) { this.shared.isCryptoSelect = value }
    },
    nonCryptoWallets() {
      return this.wallets.filter(w => w.key === 'main' || w.key === 'commission')
    },
    isIntegerWallet() {
      return !this.selectedWallet ||
        this.selectedWallet.wallet_type === 'main' ||
        this.selectedWallet.wallet_type === 'commission'
    },
    filteredWallets() {
      const hasCrypto = this.availableWithdrawalTypes[3]
      const hasNonCrypto = this.availableWithdrawalTypes[1] || this.availableWithdrawalTypes[2]
      let result = []

      if (this.withdrawType === 3) {
        result = this.wallets.filter(w => w.key !== 'main' && w.key !== 'commission')
      } else if (this.withdrawType === 1 || this.withdrawType === 2) {
        result = this.wallets.filter(w => w.key === 'main' || w.key === 'commission')
      } else {
        if (hasCrypto && hasNonCrypto) result = this.wallets
        else if (hasCrypto) result = this.wallets.filter(w => w.key !== 'main' && w.key !== 'commission')
        else if (hasNonCrypto) result = this.wallets.filter(w => w.key === 'main' || w.key === 'commission')
      }

      const sortOrder = ['main', 'bonus', 'commission']
      return result.slice().sort((a, b) => {
        const ai = sortOrder.indexOf(a.key)
        const bi = sortOrder.indexOf(b.key)
        return (ai === -1 ? sortOrder.length : ai) - (bi === -1 ? sortOrder.length : bi)
      })
    },
    withdrawalLimit() {
      const wallet = this.selectedWallet
      if (wallet && wallet.withdrawal_limit && this.filteredWallets.length > 0) {
        const limit = parseFloat(wallet.withdrawal_limit) - parseFloat(wallet.turnover)
        return limit > 0 ? Math.floor(limit * 1e6) / 1e6 : 0
      }
      return 0
    },
    amount_limit() {
      const wallet = this.selectedWallet
      if (wallet && wallet.amount_limit && this.filteredWallets.length > 0) {
        if (wallet.name === 'main' || wallet.name === 'commission') {
          return parseInt(wallet.amount_limit.max)
        }
        return Math.floor(Number(wallet.amount_limit.max) * 1e6) / 1e6
      } else if (wallet && wallet.symbol) {
        const cryptoWallet = this.wallets.find(item => item.name === wallet.symbol)
        const limit = Math.floor(Number(cryptoWallet.amount_limit.max) * 1e6) / 1e6
        return limit > 0 ? limit : 0
      }
      return 0
    }
  },
  watch: {
    wallets: {
      handler(wallets) {
        if (wallets.length === 0 || this.defaultInitialized) return
        this.initDefaultMode()
      },
      immediate: true
    },
    coinList() {
      this.syncSelectedCoin()
    },
    filteredWallets(newList) {
      if (newList.length === 0) {
        this.selectedWallet = null
        this.postForm.wallet_type = null
      } else if (this.withdrawType === 1 || this.withdrawType === 2) {
        const key = this.isMainWallet ? 'main' : 'commission'
        this.postForm.wallet_type = key
        this.selectedWallet = this.getWalletByKey(key)
        this.selectedWalletKey = key
      }
    },
    selectedCoin: {
      handler(newCoin) {
        if (newCoin && newCoin.networks) {
          this.chainList = Object.values(newCoin.networks).map(network => ({
            chain: network.chain,
            supportMemo: network.supportMemo
          }))
          this.selectedChain = this.chainList[0] || null
          this.selectedWallet = newCoin
          this.postForm.wallet_type = newCoin.symbol
        } else {
          this.chainList = []
          this.selectedChain = null
        }
      },
      immediate: true
    }
  },
  created() {
    // from personal page is only meaningful for normal withdrawal mode.
    if (localStorage.getItem('fromPersonalToWithdrawal')) {
      localStorage.removeItem('fromPersonalToWithdrawal')
      this.postForm.wallet_type = 'commission'
      this.isMainWallet = false
    }

    getMyBanks().then((response) => {
      this.myBanks = response.data.data
      this.checkAvailableWithdrawalTypes()
    }).catch((error) => {
      setErrorMessage(error.response, this.errors)
    })

    if (this.withdrawalLimit !== 0 && this.postForm.wallet_type === 'main') {
      showNotice(this.$t('Bao.no_withdrawal_limit', { limit: this.withdrawalLimit }))
    }

    this.preloadTypeDescriptions([1, 2, 3])
  },
  methods: {
    getWalletImagePath(...args) {
      return this.common.getWalletImagePath(...args)
    },
    getWalletByKey(key) {
      return this.common.getWalletByKey(key)
    },
    initDefaultMode() {
      const selectedWallet = this.app.selectedWallet
      if (this.isTheme('theme_purple')) {
        this.withdrawType = 3
      } else if (!selectedWallet || Object.keys(selectedWallet).length === 0 ||
        ['main', 'commission', 'bonus'].includes(selectedWallet.wallet_type)) {
        this.withdrawType = 2
      } else {
        this.withdrawType = 3
      }

      const sw = this.app.selectedWallet
      const isCryptoWallet = sw &&
        Object.keys(sw).length > 0 &&
        this.wallets.some(w => w.key === sw.wallet_type)

      if (isCryptoWallet) {
        this.selectedCoin = {
          symbol: sw.wallet_type,
          balance: sw.balance ?? '0',
          networks: sw.networks ?? null
        }
        this.selectedWallet = this.selectedCoin
        this.selectedWalletKey = sw.wallet_type
        this.postForm.wallet_type = sw.wallet_type
        this.syncSelectedCoin()
      } else if (!this.isTheme('theme_purple')) {
        this.selectedWallet = this.getWalletByKey('main')
        this.selectedWalletKey = 'main'
      }

      this.defaultInitialized = true
    },
    syncSelectedCoin() {
      if (this.coinList.length === 0) return

      if (this.selectedCoin) {
        const fullCoin = this.coinList.find(c => c.symbol === this.selectedCoin.symbol)
        if (fullCoin) {
          this.selectCrypto(fullCoin)
        } else if (this.isTheme('theme_purple')) {
          this.selectedCoin = null
          this.selectCrypto(this.coinList[0])
        } else {
          this.selectedCoin = null
          this.selectedWallet = this.getWalletByKey('main')
          this.selectedWalletKey = 'main'
          this.postForm.wallet_type = 'main'
          this.withdrawType = 2
        }
        return
      }

      if (this.isTheme('theme_purple')) {
        this.selectCrypto(this.coinList[0])
      }
    },
    onSelectCrypto(coin) {
      this.withdrawType = 3
      this.selectCrypto(coin)
    },
    onSelectChain(chainObj) {
      this.selectedChain = chainObj
    },
    selectNonCryptoWallet(wallet) {
      this.withdrawType = 2
      this.selectedCoin = null
      this.selectedChain = null
      this.chainList = []
      this.selectedWalletKey = wallet.key
      this.selectedWallet = this.getWalletByKey(wallet.key)
      this.postForm.wallet_type = wallet.key
    },
    onSelectBank(bank) {
      this.selectedBankName = bank.card_number
      this.postForm.member_bank_id = bank.id
      this.selectedBankTypeCode = bank.code || ''
      this.withdrawal_info = {}
    },
    selectCrypto(coin) {
      this.selectedCoin = coin
      this.isCryptoSelect = true
      this.selectedCoin.payment_fee = this.getWithdrawalPaymentFee(coin.symbol)
    },
    getWithdrawalPaymentFee(symbol) {
      if (Array.isArray(this.paymentFeeData)) {
        const matchedFee = this.paymentFeeData.find(fee => fee.code === symbol)
        return matchedFee?.payments?.[0]?.payment_fee?.member
      }

      const paymentBanks = this.findWithdrawalPaymentBanks(symbol)
      if (paymentBanks.length === 0) return undefined
      const paymentBankIds = paymentBanks.map(bank => String(bank.id))

      const providerSettings = this.paymentFeeData?.brand_payment_provider || []
      for (const providerSetting of providerSettings) {
        const bankSetting = (providerSetting.brand_payment_provider_bank || [])
          .find(item => paymentBankIds.includes(String(item.payment_bank_id)))
        if (!bankSetting) continue

        const paymentFee = this.getPaymentFeeMember(bankSetting.payment_fee || providerSetting.payment_fee)
        if (paymentFee !== undefined) return paymentFee
      }

      return undefined
    },
    findWithdrawalPaymentBanks(symbol) {
      const banks = this.paymentFeeData?.payment_bank || []
      const normalizedSymbol = String(symbol || '')
      const exactMatches = []
      const prefixMatches = []
      const nameMatches = []

      banks.forEach(bank => {
        const code = String(bank.code || '')
        const name = String(bank.bank_name || bank.name || '')
        const currency = String(bank.currency || '')

        if (code === normalizedSymbol || name === normalizedSymbol || currency === normalizedSymbol) {
          exactMatches.push(bank)
        } else if (code.split('_')[0] === normalizedSymbol) {
          prefixMatches.push(bank)
        } else if (name.includes(normalizedSymbol)) {
          nameMatches.push(bank)
        }
      })

      return exactMatches.concat(prefixMatches, nameMatches)
    },
    getPaymentFeeMember(paymentFee) {
      if (!paymentFee) return undefined
      if (typeof paymentFee === 'number' || typeof paymentFee === 'string') return paymentFee
      return paymentFee.withdrawal?.member ?? paymentFee.member ?? paymentFee.deposit?.member
    },
    setAllAmount() {
      if (!this.selectedWallet) { this.postForm.amount = 0; return }
      if (this.selectedWallet.wallet_type === 'main' || this.selectedWallet.wallet_type === 'commission') {
        this.postForm.amount = parseInt(this.selectedWallet['amount_limit'].max)
      } else {
        this.isWithdrawalFull = true
        const cryptoWallet = this.wallets.find(item => item.name === this.selectedWallet.symbol)
        this.fullAmount = Number(cryptoWallet.amount_limit.max)
        const limit = Math.floor(this.fullAmount * 1e6) / 1e6
        this.postForm.amount = limit > 0 ? limit : 0
      }
    },
    checkInput() {
      const amountValid = this.postForm.amount !== '' && !isNaN(this.postForm.amount)
      const hasWallet = !!this.selectedWallet
      const passedAuth = this.google_auth_totp_status
        ? !!this.postForm.opt_code
        : !!this.postForm.withdrawal_pass
      const hasAgreed = this.agree
      const bankSelected = !isNaN(this.postForm.member_bank_id)
      const isJetonInvalid = this.selectedBankTypeCode === 'JetonPay' && this.jetonErrors.length > 0
      const isVegaInvalid = this.selectedBankTypeCode === 'VegaWallet' &&
        (!this.withdrawal_info.password || this.accountErrors.length > 0)

      return amountValid && hasWallet && this.isWithdraw &&
        (this.withdrawType === 3 || bankSelected) &&
        (this.withdrawType === 3 ? !!this.postForm.address : true) &&
        (this.withdrawType === 3 ? !!this.selectedChain : true) &&
        (this.withdrawType === 3 ? !!this.selectedCoin : true) &&
        (this.withdrawType === 3 && this.selectedChain?.supportMemo ? !!this.memo : true) &&
        hasAgreed && passedAuth && !isJetonInvalid && !isVegaInvalid
    },
    checkAccountErrors() {
      this.accountErrors = []
      if (!this.withdrawal_info.uid || !/^[a-zA-Z]\d{6}$/.test(this.withdrawal_info.uid)) {
        this.accountErrors.push(this.$t('Bao.deposit_account_error'))
      }
    },
    checkJetonErrors() {
      this.jetonErrors = []
      if (!this.withdrawal_info.uid || !/^\d+$/.test(this.withdrawal_info.uid)) {
        this.jetonErrors.push(this.$t('Bao.jeton_account_error'))
      }
    },
    checkIsWithdraw() {
      if (this.postForm.amount <= 0 || isNaN(this.postForm.amount)) {
        showNotice(this.$t('Bao.withdrawal_amount') + ' ' + this.$t('Bao.need_over_zero'))
        return
      }
      if (this.postForm.wallet_type !== 'commission' &&
        this.first_deposit_at === 0 &&
        this.before_withdrawal_module_setting !== null) {
        if (this.postForm.amount > this.max_withdrawal_amount) {
          this.postForm.amount = this.max_withdrawal_amount
        }
        this.showModel = true
      } else {
        this.doWithdrawal()
      }
    },
    doWithdrawal() {
      this.showModel = false
      const withdrawAmount = this.isWithdrawalFull ? this.fullAmount : this.postForm.amount

      withdrawalCheck({ amount: withdrawAmount, wallet_type: this.postForm.wallet_type })
        .then((response) => {
          if (response.data.data.status === 'deny') {
            showNotice(response.data.data.message)
          } else {
            this.withdrawalCheckData = response.data.data
          }
        })
        .catch(() => console.log('Cannot get wallet type'))

      const encryptedPostForm = { ...this.postForm }

      if (this.withdrawType === 3) {
        encryptedPostForm.chain = this.selectedChain.chain
        encryptedPostForm.member_bank_id = null
        encryptedPostForm.memo = this.selectedChain.supportMemo ? this.memo : ' '
      } else {
        encryptedPostForm.address = null
        delete encryptedPostForm.chain
        delete encryptedPostForm.memo
      }

      if (this.selectedBankTypeCode === 'VegaWallet') {
        encryptedPostForm.withdrawal_info = {
          ...this.withdrawal_info,
          password: crypto.MD5(this.withdrawal_info.password).toString()
        }
      } else if (this.selectedBankTypeCode === 'JetonPay') {
        encryptedPostForm.withdrawal_info = { ...this.withdrawal_info }
      } else {
        delete encryptedPostForm.withdrawal_info
      }

      const withdrawalInfoString = JSON.stringify(encryptedPostForm.withdrawal_info)

      withdrawalPayment({ ...encryptedPostForm, withdrawal_info: withdrawalInfoString })
        .then((response) => {
          showNotice(response.data.msg, () => {
            this.$router.push({ path: '/user/transaction-history?type=withdrawRecord' })
          })
        })
        .catch((error) => {
          setErrorMessage(error.response, this.errors)
        })
    },
    checkAvailableWithdrawalTypes() {
      this.availableWithdrawalTypes = { 1: false, 2: false, 3: true }
      const banksByType = {}
      this.myBanks.forEach(bank => {
        if (!banksByType[bank.bank_type]) banksByType[bank.bank_type] = []
        banksByType[bank.bank_type].push(bank)
      })
      Object.entries(banksByType).forEach(([type, banks]) => {
        const hasPayments = banks.some(b => Array.isArray(b.payments) && b.payments.length > 0)
        if (hasPayments) {
          if (parseInt(type) === 1) this.availableWithdrawalTypes[1] = true
          if (parseInt(type) === 2) this.availableWithdrawalTypes[2] = true
        }
      })
    },
    copyTextHelper(msg) {
      copyText(msg, this.memo)
    },
    isMobile() {
      return detectMob()
    }
  }
}
</script>

<style scoped>
.my-wrap .content {
  background-color: var(--bg-primary) !important;
  border: none !important;
  padding: 40px !important;
}
.popup-success button.button-style-5 {
  margin-left: 10px;
}
</style>
